import { getGraphQLClient } from 'utilities/graphql';

import AcceptInviteLinkInvitation from './AcceptInviteLinkInvitation.gql';

export const requestAcceptInviteLink = async (inviteLinkId, isNewUser) => {
  const client = getGraphQLClient();

  const {
    data: { acceptInviteLinkInvitation: result },
  } = await client.mutate({
    mutation: AcceptInviteLinkInvitation,
    variables: { inviteLinkId, isNewUser },
  });

  return result;
};
